import {
    RegistrationRefData,
    NewAccountRequest,
    NewAccountResponse,
    AddressSearchResponse,
    AddressMetadataResponse
} from "../entities/RegistrationEntities";
import { executeGet, executePost } from "./ServiceHelper";

export function registerNewAccount(request: NewAccountRequest): Promise<NewAccountResponse> {
    return executePost<NewAccountResponse>(request, "api/registration/newAccount");
};

export function getRegistrationRefData(): Promise<RegistrationRefData> {
    return executeGet<RegistrationRefData>("api/registration/referenceData");
};

export function searchAddress(queryString: string, includePoBox:boolean = true): Promise<AddressSearchResponse> {
    return executeGet<AddressSearchResponse>(`api/registration/addressSearch?queryString=${queryString}&includePoBox=${includePoBox}`);
};

export function getAddressMetadata(pxid: string): Promise<AddressMetadataResponse> {
    return executeGet<AddressMetadataResponse>("api/registration/addressMetadata?pxid=" + pxid);
};
